<template>
    <div id="mainwrap" v-if="isLoggedIn">
        <header id="topbar">
            <app-toolbar :showSidebar="showSidebar" @showSidebar="showSidebar=$event"></app-toolbar>
        </header>
        <router-view id="bottom" :showSidebar="showSidebar" @showSidebar="showSidebar=$event"></router-view>

        <full-screen-editor v-if="$store.state.messageEditorMode===1" :message="composedMessage"></full-screen-editor>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import FullScreenEditor from '@/components/fullScreenEditor';
import AppToolbar from '@/components/appToolbar';
import { EventBus } from '@/event-bus';

export default {
  name: 'mainApp',
  components: { FullScreenEditor, AppToolbar },
  data: function() {
    return {
      composedMessage: {},
      showSidebar: false
    };
  },
  created() {
    EventBus.$on('compose', msg => {
      this.composedMessage = msg;
      this.$store.commit('setEditorMode', 1);
    });
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>

<style lang="scss">
    #mainwrap {
        position: absolute;
        width: 100vw;
        height: 100vh;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 40px calc(100vh - 40px);
        grid-template-areas: "topbar" "bottom";

        #topbar {
            // height: 40px;
            grid-area: topbar;
        }

        #bottom {
            grid-area: bottom;
            overflow: hidden;
        }
    }
</style>
